import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { loginUserWithCredentials, validateToken } from './action';
import { push } from 'react-router-redux/actions';
import { CenterContainer, Box, Stack, Separator } from '../../components/containers';
import { Button, ButtonRounded } from '../../components/actions';
import { Headline, ErrorBox } from '../../components/text';
import { Input } from '../../components/fields';
import { DEFAULT_PAGE } from '../../App';
import { selectIsUserAuthorized } from '../../selectors';
import s from './index.css';

const LOGIN_STATUS = {
    None: 0,
    Loading: 1,
    Success: 5,
    Error: -1,
    ErrorAllFieldsAreRequired: -2,
};

const mapStateToProps = state => ({
    isUserLoggedIn: selectIsUserAuthorized(state),
});

const mapDispatchToProps = dispatch => ({
    loginAction: bindActionCreators(loginUserWithCredentials, dispatch),
});

class LoginPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            status: LOGIN_STATUS.None,
            form: {
                email: '',
                password: '',
            },
        };
    }

    render() {
        const { handleSubmit, error } = this.props;

        return (
            <CenterContainer>
                <Box className={s.container} addPadding={true}>
                    <form onSubmit={this.submitLoginForm}>
                        <Headline size="medium">Reports portal</Headline>

                        <ErrorBox
                            hide={this.state.status >= 0}
                            label={
                                this.state.status === LOGIN_STATUS.ErrorAllFieldsAreRequired
                                    ? 'All fields are required'
                                    : 'Could not login, please try again'
                            }
                        />

                        <Input
                            tabIndex={1}
                            type="email"
                            placeholder="Email address"
                            value={this.state.form.email}
                            onChange={this.handleFieldChange('email')}
                        />

                        <Input
                            tabIndex={2}
                            type="password"
                            placeholder="Password"
                            value={this.state.form.password}
                            onChange={this.handleFieldChange('password')}
                        />

                        <Separator type="huge" />

                        <Stack>
                            <div />
                            {/* <ButtonRounded
                                onClick={this.goToPasswordForgotten}
                                type="button"
                                tabIndex={4}
                                align="left"
                                label="Forgot password?"
                            /> */}

                            <Button
                                type="submit"
                                withBox={true}
                                align="right"
                                tabIndex={3}
                                isLoading={this.state.status === LOGIN_STATUS.Loading}
                                label={this.state.status === LOGIN_STATUS.Loading ? 'Signing in' : 'Sign in'}
                            />
                        </Stack>
                    </form>
                </Box>
            </CenterContainer>
        );
    }

    handleFieldChange = field => e => {
        this.setState({
            form: {
                ...this.state.form,
                [field]: e.target.value,
            },
        });
    };

    submitLoginForm = e => {
        e.preventDefault();
        e.stopPropagation();

        if (this.state.status === LOGIN_STATUS.Loading) {
            return;
        }

        const username = this.state.form.email.trim();
        const password = this.state.form.password;

        if (username.length <= 0 || password.length <= 0) {
            this.setState({
                status: LOGIN_STATUS.ErrorAllFieldsAreRequired,
            });
            return;
        }

        this.setState({
            status: LOGIN_STATUS.Loading,
        });

        this.props
            .loginAction({
                email: username,
                password,
            })
            .then(success => {
                this.setState({
                    status: LOGIN_STATUS.Success,
                });

                this.props.dispatch(push(DEFAULT_PAGE));
            })
            .catch(response => {
                this.setState({
                    status: LOGIN_STATUS.Error,
                    form: {
                        ...this.state.form,
                        password: '',
                    },
                });
            });
    };

    // goToPasswordForgotten = e => {
    //     e.preventDefault();
    //     this.props.dispatch(push(PAGE_GENERAL.PasswordForgotten));
    // };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LoginPage);



// WEBPACK FOOTER //
// ./app/web/src/container/LoginPage/index.jsx